import { AuthToken, ConsoleLogger, JSONMarshallerImpl, LogLevel } from '@playq/irt';

import type { HTTPCachedTransport } from '/api/cachedTransport';
import { createTransport } from '/api/transport';
import { createWebsocketTransport } from '/api/websocketTransport';
import { logSnackbarError } from '/common/snackbarService';

const marshaller = new JSONMarshallerImpl(true);
const logger = new ConsoleLogger(LogLevel.Warning);

export const transport = createTransport(marshaller, logger, 3) as HTTPCachedTransport;
export const websocketTransport = createWebsocketTransport(marshaller, logger, 3);

export const setAuthorization = (access: string) => {
  const token = new AuthToken(access);
  transport.setAuthorization(token);
  websocketTransport.setAuthorization(token);
};

export const resetAuthorization = () => {
  transport.setAuthorization(undefined);
  websocketTransport.setAuthorization(undefined);
};

export const clearCache = () => {
  transport.clearAll();
};

export const tryToSendEphemeral = async <R>(
  method: () => Promise<R>,
  resolveDefault: () => R | Promise<R>,
  logErrorToSnackbar?: boolean
): Promise<R> => {
  const isReady = websocketTransport.getAuthorization() !== undefined && websocketTransport.isReady();

  if (!isReady) {
    return resolveDefault();
  }

  try {
    return await method();
  } catch (e) {
    console.error('[Ephemeral Error]:', e);

    if (logErrorToSnackbar) {
      logSnackbarError(e, false);
    }

    return resolveDefault();
  }
};
